// import { cookiesConsent } from './helpers/cookies_consent';
import jQuery from "jquery";
window.jQuery = jQuery;
// // ! Cookies consent
// const cookiesPopup = document.querySelector('#cookies');
// const allowBtnCookies = document.querySelector('.cookies_consent_btn');
// const cookiesName = 'joriside_';

// if (cookiesPopup && allowBtnCookies && cookiesName) {

//     cookiesConsent(cookiesPopup, allowBtnCookies, cookiesName);
// }

function scrollTop() {
    const scrollTop = document.querySelector(".scrolltop");
    if (this.scrollY >= 560) scrollTop.classList.add("show-scroll");
    else scrollTop.classList.remove("show-scroll");
}
window.addEventListener("scroll", scrollTop, {passive: false});

window.openVertical= function(){
    var targetNavMenu = document.querySelector('.q10__header__top__menu');
    var closeXVertical = document.querySelector('.close_x_vertical');
    var whiteDotsVertical = document.querySelector('.white_dots_vertical');
    if (targetNavMenu.style.display !== "flex") {
        targetNavMenu.style.display = "flex";
        closeXVertical.style.display = "flex";
        whiteDotsVertical.style.display = "none";

        } else if (targetNavMenu.style.display !== "none") {
            targetNavMenu.style.display = "none";
            closeXVertical.style.display = "none";
            whiteDotsVertical.style.display = "block";
        }
}


window.openMenu= function(){
    var targetMenu = document.querySelector(".dropdown-content")
    var selectMenu = document.querySelector("#selected")
    if (targetMenu.style.display === "block") {
    targetMenu.style.display = "none";
    selectMenu.style = "box-shadow: 0;"
    } else {
    targetMenu.style.display = "block";

    selectMenu.style = "box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;"
    }
}

window.addEventListener("openMenu", openMenu);
//check if resonsive and hide menu for Mobile

window.addDisplayFlexOnDesktop = function() {
//Close slect Menu (targetNameAndIcon), at resizing
targetNameAndIcon.style.display = 'none';
targetNameAndIcon.style = 'box-shadow: none';
var targetNavMenu = document.querySelector('.q10__header__top__menu');
var responsiveCheck = window.matchMedia("(min-width: 1025px)")
    if (responsiveCheck.matches) { // If media query matches
        targetMenu.style.display = "flex";
        targetNavMenu.style.display = "flex";
    } else {
        targetMenu.style.display = "none";
    }
}
//Make function above listen to resize window
window.addEventListener('addDisplayFlexOnDesktop', addDisplayFlexOnDesktop);

// jQuery.event.special.touchstart = {
//     setup: function( _, ns, handle ) {
//         this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
//     }
// };
// jQuery.event.special.touchmove = {
//     setup: function( _, ns, handle ) {
//         this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
//     }
// };
// jQuery.event.special.wheel = {
//     setup: function( _, ns, handle ){
//         this.addEventListener("wheel", handle, { passive: true });
//     }
// };
// jQuery.event.special.mousewheel = {
//     setup: function( _, ns, handle ){
//         this.addEventListener("mousewheel", handle, { passive: true });
//     }
// };